import React from "react";
import duration from "../Assets/Images/duration.png";
import calendar from "../Assets/Images/calendar.png";
import returns from "../Assets/Images/returns.png";
import profit from "../Assets/Images/profit.png";
import pace from "../Assets/Images/pace.png";
import { timeformatter } from "../utils/dateformatter";

import { formatAmount } from "../utils/formatAmount";
import { CiMemoPad } from "react-icons/ci";
import { useSelector } from "react-redux";

const CampaignCard = ({
  investmentCategory,
  title,
  investment_type,
  roi_range,
  type,
  dueDate,
  launchDate,
  noButton,
  tenure,
  investment_memo,
  payoutType,
  nReturn,
  onClick,
  invested,
  totalAmount,
  currency,
  showTimelines,
  investors,
  status,
  noTag,
}) => {
  const { user } = useSelector((state) => state.onboarding);

  const percentageInvested =
    (invested / totalAmount) * 100 < 100
      ? ((invested / totalAmount) * 100).toFixed(1)
      : (invested / totalAmount) * 100;
  return (
    <div
      className={`mb-[20px] py-5 px-5 w-full max-w-[512px] ${
        status == 9 ? "min-h-[174px]" : type === "small" ? "" : "min-h-[264px]"
      } rounded-[14px] border-[1px] shadow-sm border-[#F0F0F5]`}
    >
      <div className="flex gap-3 items-start justify-between">
        <div className="flex gap-3 items-start">
          <div className="text-[16px] font-[500] text-[#131E3D]">{title}</div>
          {status == 9 ? (
            <div className="gap-[5px] flex rounded-[12px]  h-[25px]  px-2 text-[12px] bg-[#E4FFC2] justify-center items-center ">
              <h3 className=" font-[500] text-[12px]  text-[#344616]  ">
                Upcoming
              </h3>
            </div>
          ) : (
            <></>
          )}
        </div>
        {noTag ? (
          <></>
        ) : (
          <h3 className=" font-[500] text-[12px]  text-[#344616]  ">
            {investmentCategory?.name?.toLowerCase() ===
            "none interest commercial paper (nicp)"
              ? "NICP"
              : investmentCategory?.name?.toLowerCase() === "sme financing"
              ? "Business Financing"
              : investmentCategory?.name || "Real Estate"}
          </h3>
        )}
      </div>
      <div className="mt-[10px]">
        <div className="flex gap-[10px] items-center">
          {status == 9 ? (
            dueDate ? (
              <div className="  gap-[5px] flex items-center">
                <img src={duration} alt="" className=" w-[14px] h-[14px] " />
                <div className="text-[12px] font-[400] text-[#9C9C9E]">
                  Expected launch {timeformatter(dueDate, "formal")}
                </div>
              </div>
            ) : (
              <></>
            )
          ) : dueDate ? (
            <div className="  gap-[5px] flex items-center">
              <img src={duration} alt="" className=" w-[14px] h-[14px] " />
              <div className="text-[12px] font-[400] text-[#9C9C9E]">
                Campaign Due {timeformatter(dueDate, "formal")}
              </div>
            </div>
          ) : (
            <></>
          )}

          {tenure ? (
            <div className="flex gap-[5px] items-center">
              <img src={calendar} alt="" className=" w-[14px] h-[14px] " />
              <div className="text-[12px] font-[400] text-[#9C9C9E]">
                {investmentCategory?.name?.toLowerCase() === "sme financing" ||
                investmentCategory?.name?.toLowerCase() ===
                  "none interest commercial paper (nicp)"
                  ? tenure?.includes("week") || tenure?.includes("Month")
                    ? tenure
                    : `${tenure} month${Number(tenure) === 1 ? "" : "s"}`
                  : `${tenure} year${Number(tenure) === 1 ? "" : "s"}`}{" "}
                Tenure
              </div>
            </div>
          ) : (
            <></>
          )}

          <div className="flex gap-[5px] items-center">
            <img src={returns} alt="" className=" w-[14px] h-[14px] " />
            <div className="text-[12px] font-[400] text-[#20A43D]">
              {investment_type?.toLocaleLowerCase() === "mudarabah"
                ? `ROI Range (${roi_range?.min_roi} - ${roi_range?.max_roi}%)`
                : `${nReturn}% Net Return`}
            </div>
          </div>
        </div>
        {payoutType ? (
          <div className="flex gap-[5px] items-center mt-2">
            <img src={profit} alt="" className="w-[14px] h-[14px] " />
            <div className="text-[12px] capitalize font-[400] text-[#9C9C9E]">
              {payoutType}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      {status == 9 ? (
        <div className="text-[14px] mt-[16px] text-[#131E3D] font-[500]">
          <span className="font-[400]">Investment Amount: </span>
          {currency}
          {formatAmount(totalAmount)}
        </div>
      ) : (
        <div className={type === "small" ? "mt-[16px]" : "mt-[40px]"}>
          {status == 9 ? (
            <div className="text-[14px] text-[#131E3D] font-[400]">
              {percentageInvested
                ? Number(100 - percentageInvested)?.toFixed(2)
                : "0.0"}
              % slots available of {currency}
              {formatAmount(totalAmount)}
            </div>
          ) : (
            <div className="text-[14px] text-[#131E3D] font-[400]">
              {percentageInvested
                ? Number(percentageInvested)?.toFixed(2)
                : "0.0"}
              % invested of {currency}
              {formatAmount(totalAmount)}
            </div>
          )}
          <div className="w-full bg-[#F2F2F7] h-[4px] overflow-hidden rounded-full mt-2">
            <div
              className="bg-[#20A43D] h-full "
              style={{ width: `${percentageInvested}%` }}
            ></div>
          </div>
        </div>
      )}
      <div
        className={`flex-wrap gap-2 flex justify-between items-center ${
          type === "small" ? "mt-[16px]" : "mt-[30px]"
        }`}
      >
        {noButton ? (
          <></>
        ) : (
          <button
            onClick={onClick}
            className=" text-[14px] font-[500] flex items-center bg-[#6935D3] text-white py-2 px-4 rounded-[8px]"
          >
            {status == 9
              ? "⁠Book Slot"
              : investors &&
                investors?.find(
                  (investor) =>
                    investor?.user_id === user?.id ||
                    investor?.user?.id === user?.id
                )
              ? "Add More Funds"
              : "Invest now"}
          </button>
        )}
        {status == 9 ? (
          <></>
        ) : (
          <>
            <div
              className={`flex gap-[5px]  items-center ${
                investment_memo || title === "Neemah_5"
                  ? "cursor-pointer"
                  : "cursor-not-allowed opacity-[0.7]"
              }`}
            >
              <CiMemoPad className="text-[#6935D3] " />
              <a
                rel="noreferrer"
                href={
                  title === "Neemah_5"
                    ? "/Neemah.pdf"
                    : investment_memo
                    ? investment_memo
                    : null
                }
                download={`${title} Documents`}
                target="_blank"
              >
                <div className={`text-[14px] font-[400] text-[#6935D3] `}>
                  Read Memo
                </div>
              </a>
            </div>

            <div
              onClick={showTimelines}
              className=" flex gap-[5px] cursor-pointer items-center"
            >
              <img src={pace} alt="" className=" w-[14px] h-[14px] " />
              <div className=" text-[14px] font-[400] text-[#6935D3] ">
                Campaign Timeline
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CampaignCard;
